import { api, headersConfig } from "../../services/api";

const service_path = '/services.php';

export async function getServices() {

    const response = await api.get(service_path, headersConfig);

    return response;
};

export async function createService(payload) {

    const response = await api.post(service_path, payload, headersConfig);

    return response;
};